import { Typography } from '@mui/material';
import React from 'react';

function ErrorFallbackView() {
  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', marginTop: '7rem', textAlign: 'center' }}>
      <Typography variant="caption" gutterBottom component="div">
        Clique no logo para recarregar a página.
      </Typography>
      <img
        src="/images/logos/logo-test.png"
        height="100"
        style={{ cursor: 'pointer', borderRadius: '50%', marginBottom: '1rem' }}
        alt="Clique aqui para recarregar"
        onClick={() => {
          window.location.replace('/');
        }}
      />

      <Typography variant="h5" gutterBottom>
        Desculpe-nos, algo inesperado aconteceu.
      </Typography>
      <Typography variant="subtitle1" gutterBottom>
        Por favor contate nossa equipe de suporte.
      </Typography>
    </div>
  );
}

export default ErrorFallbackView;
